import { DefineComponent, FunctionalComponent } from "vue";

interface FieldValidationMessageProps
{
    forId: string;
    isError?: boolean;
}

const FieldValidationMessage: FunctionalComponent<FieldValidationMessageProps> = function (props: FieldValidationMessageProps, context)
{
    return (
        <span class={{
            "fieldValidationMessage": true,
            "help": true,
            "error": props.isError,
            }} data-validate-message-for={props.forId} {...context.attrs}>
            {context.slots.default && context.slots.default()}
        </span>
    );
};

FieldValidationMessage.props = ["forId", "isError"];
export default FieldValidationMessage as unknown as DefineComponent<FieldValidationMessageProps, JSX.Element>;
